// extracted by mini-css-extract-plugin
export var buttonBase = "styles-module__buttonBase___AOFVV";
export var blockButton = "styles-module__blockButton___RiLhm";